import axios from "axios";
import { rateLimitingUrl } from "../pages/members/Shared/Constants/AppConstant";

const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    },
    baseURL: '/api'
});

api.interceptors.request.use(
    function (config: any) {
        let token = window.sessionStorage.getItem(
            localStorage.getItem('accessTokenVariable')??""
        );

        if (token) {
            const oidcStorage = JSON.parse(token);

            if (!!oidcStorage && !!oidcStorage.access_token) {
                config.headers.Authorization = `Bearer ${oidcStorage.access_token}`;
            }
        }

        return config;
    },
    function (err:any) {
        return Promise.reject(err);
    }
);

api.interceptors.response.use(
    res => res,
    async err => {
        if (err.response.status === 429 && window.location.pathname != rateLimitingUrl) {
            window.location.href = rateLimitingUrl;
        }
        async function handleDelay() {
            if (err.response.status === 429) {
                await delay(1000000);
            } else {
                await delay(100);
            }
            return Promise.reject(err);
        }
        await handleDelay();
    }
);

function delay(ms:any) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default api;
